import { render, staticRenderFns } from "./userSelect.vue?vue&type=template&id=36aecda8&scoped=true&"
import script from "./userSelect.vue?vue&type=script&lang=js&"
export * from "./userSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aecda8",
  null
  
)

export default component.exports